import { toB64, fromB64 } from '@/helpers';
import delay from '@/helpers/mixins/delay.js';
import $router from '@/router';

export default {
  mixins: [delay],
  methods: {
    async updateUrlQuery(key, obj) {
      const payload = { };
      Object.keys(obj)
        .filter(key => !!obj[key])
        .forEach(key => payload[key] = obj[key]);

      const encoded = toB64(JSON.stringify(payload, 'string'));

      const $route = $router.history.current
      if ($route.query[key] != encoded) {
        const route = {
          name: $route.name,
          query: { ...$route.query }
        }
        route.query[key] = encoded;
        
        this.delay('updateUrlQuery', $router.replace.bind($router), 150, route)
      }
    },
    getUrlQuery(key) {
      const $route = $router.history.current;
      const item = $route.query[key];
      return item 
        ? JSON.parse(fromB64(item, 'utf8')) 
        : null;
    },
  }
};
